import CryptoJS from 'crypto-js';

export function stringToBase64(message) {
	const encodedWord = CryptoJS.enc.Utf8.parse(message); // encodedWord Array object
	const encoded = CryptoJS.enc.Base64.stringify(encodedWord); // string: 'NzUzMjI1NDE='
	return encoded;
}
